// pkg198 — /payment-methods client route (ClientPaymentMethodsPage: saved LawPay methods, autopay, plan view) — delivered 2026-11-01
// pkg195 — /admin/accounting/import route (AdminPaymentImportPage, owner) — delivered 2026-10-31
// pkg193 — /admin/accounting route (AdminAccountingPage, view_billing) — delivered 2026-10-31
// pkg174 — /admin/dashboard/payments route (AdminPaymentsPage, view_billing) — delivered 2026-10-03
// pkg172a — /billing client route (ClientBillingPage: invoices, payments, trust balance, LawPay pay) — delivered 2026-10-03
// pkg159 — route: /admin/dashboard/hq/marketing → AdminHQMarketingEmailsPage (owner-gated, is_hq server-side) — delivered 2026-08-18
// pkg153 — route: /admin/dashboard/hq/emails → AdminHQOnboardingEmailsPage (owner-gated, is_hq enforced server-side like the hq route); HQ shell nav link added in AdminLayout — delivered 2026-08-18
// pkg148 — route: /admin/dashboard/discovery-analysis → AdminDiscoveryAnalysisLandingPage (edit_clients — the MightyAnalyzer nav landing/client picker; the per-client analyzer route is unchanged) — delivered 2026-08-16
// pkg144 — /adoption-intake client route → AdoptionIntakePage (adoption_stepparent built-in) — delivered 2026-08-11
// pkg125 — route /admin/clients/:id/modules → AdminClientModulesPage (Client Modules workspace, edit_clients-gated) — delivered 2026-07-27
// pkg105a — route: /admin/account → AdminMyAccountPage (My Account: identity + the pkg105 signed-in-devices registry; ungated — self-scoped, every role sees only their own sessions) — delivered 2026-07-25
// pkg98 — route: /admin/dashboard/exchange → AdminExchangePage (manage_modules — the MightyExchange community module exchange) — delivered 2026-07-18
// pkg84 — public /terms and /privacy routes (LegalPages, unauthenticated — the signup checkbox links here) — delivered 2026-07-15
// pkg81 — route: /admin/clients/:id/discovery-analysis → AdminClientDiscoveryAnalysisPage (edit_clients, pkg75 precedent) — delivered 2026-07-14
// pkg80 — D-80a: at hq.lawmighty.com the bare root and /login redirect to /admin (there is no client portal on the HQ subdomain); the firm-info loading state holds a blank frame so the client login never flashes; tenant firms unchanged — delivered 2026-07-14
// pkg79 — route: /admin/dashboard/hq → AdminHQPage (owner-gated; the is_hq firm check is enforced by the backend); at hq.lawmighty.com the dashboard index redirects straight to HQ so the operator portal is the whole experience (D-79-r2) — delivered 2026-07-13
// pkg75 — route: /admin/clients/:id/correspondence → AdminClientCorrespondencePage (edit_clients, matching the backend rule) — delivered 2026-07-13
// pkg72 — LawMighty retheme: brand hex sweep (#1a1a1a→#0F1838 NAVY_DEEP, #0f0f0f→#0A1028, #f8f8f8→#F5F1E8 CREAM, #c0392b→#B85042 TERRA) — delivered 2026-07-12
// pkg68 — routes for the new Firm Billing + Firm Wallet pages, gated on purchase_billing (owners always pass; staff need the grant, D-68e/f) — delivered 2026-07-12
// pkg67b — AdminCaseTypesPage import + /admin/dashboard/case-types route removed (relic page; all its mutations have been 410 tombstones since Package 12d, D-67b8) — delivered 2026-07-12
// pkg60 — Documents lifecycle view (D-58e): /firm-modules/:id/documents replaces the Prepare and View Submissions pages; the old /prepare and /submissions routes redirect (bookmarks keep working); old page files unimported — delivered 2026-07-10
// pkg43 — route for AdminFirmModulePreparePage (attorney fills attorney-owned fields per client) — delivered 2026-07-04
// pkg36 — route for AdminInternalModuleFillPage (staff fill of internal modules) — delivered 2026-07-03
// pkg32 — route for the owner-only Emergency Alert control page
// pkg24 — removed dead trust-reconciliation page + route (backend never built) — delivered 2026-06-14
// pkg21 — routes wired for firm-private AI modules (3 admin pages + client AiModulePage) — delivered 2026-06-11
import React, { createContext, useContext, useState, useEffect, useRef } from 'react';
import { BrowserRouter, Routes, Route, Navigate, useParams } from 'react-router-dom';
import { api, publicApi } from './utils/api';
import { FirmSettingsProvider, useFirmSettings } from './contexts/FirmSettingsContext'; // useFirmSettings pkg79
import { AdminAuthProvider, useAdminAuth } from './contexts/AdminAuthContext';
import { ClientModulesProvider } from './contexts/ClientModulesContext';

import LoginPage          from './pages/LoginPage';
import { TermsPage, PrivacyPage } from './pages/LegalPages'; // pkg84
import ChangePasswordPage from './pages/ChangePasswordPage';
import DashboardPage      from './pages/DashboardPage';
import DemographicPage    from './pages/DemographicPage';
import ParentingPlanPage  from './pages/ParentingPlanPage';
import WitnessPage        from './pages/WitnessPage';
import BudgetPage            from './pages/BudgetPage';
import AssetLedgerPage       from './pages/AssetLedgerPage'; // pkg26
import AdoptionIntakePage    from './pages/AdoptionIntakePage'; // pkg144
import AccountSettingsPage  from './pages/AccountSettingsPage';
import ChildSupportPage     from './pages/ChildSupportPage';
import JuvenileInfoPage     from './pages/JuvenileInfoPage';
import ClientDiscoveryListPage      from './pages/ClientDiscoveryListPage';
import ClientBillingPage            from './pages/ClientBillingPage'; // pkg172a
import ClientPaymentMethodsPage     from './pages/ClientPaymentMethodsPage'; // pkg198
import ClientDiscoveryWorkspacePage from './pages/ClientDiscoveryWorkspacePage';
import ContentModulePage            from './pages/ContentModulePage';
import Layout             from './components/Layout';

import AdminLoginPage       from './pages/AdminLoginPage';
import AdminLayout          from './components/AdminLayout';
import RequirePermission    from './components/RequirePermission';
import AdminDashboardPage   from './pages/AdminDashboardPage';
import AdminCreateClientPage from './pages/AdminCreateClientPage';
import AdminClientsPage     from './pages/AdminClientsPage';
import AdminClosedFilesPage from './pages/AdminClosedFilesPage';
import AdminMyAccountPage   from './pages/AdminMyAccountPage'; // pkg105a
import AdminClientDetailPage from './pages/AdminClientDetailPage';
import AdminClientCorrespondencePage from './pages/AdminClientCorrespondencePage'; // pkg75
import AdminClientDiscoveryAnalysisPage from './pages/AdminClientDiscoveryAnalysisPage'; // pkg81
import AdminDiscoveryAnalysisLandingPage from './pages/AdminDiscoveryAnalysisLandingPage'; // pkg148
import AdminHQPage from './pages/AdminHQPage'; // pkg79
import AdminHQOnboardingEmailsPage from './pages/AdminHQOnboardingEmailsPage'; // pkg153
import AdminHQMarketingEmailsPage from './pages/AdminHQMarketingEmailsPage'; // pkg159
import AdminSetupPage       from './pages/AdminSetupPage';
import AdminStaffPage       from './pages/AdminStaffPage';
import AdminRolesPage       from './pages/AdminRolesPage';
import AdminGenerateInvoicePage from './pages/AdminGenerateInvoicePage';
import AdminInvoicesPage    from './pages/AdminInvoicesPage';
import AdminPaymentsPage    from './pages/AdminPaymentsPage'; // pkg174
import AdminInvoiceDetailPage from './pages/AdminInvoiceDetailPage';
import AdminTrustPage       from './pages/AdminTrustPage';
import AdminAccountingPage  from './pages/AdminAccountingPage'; // pkg193
import AdminPaymentImportPage from './pages/AdminPaymentImportPage'; // pkg195
import AdminQuickTimePage   from './pages/AdminQuickTimePage';
import AdminFirmSettingsPage from './pages/AdminFirmSettingsPage';
import AdminEmergencyAlertPage from './pages/AdminEmergencyAlertPage'; // pkg32
import AdminContactsPage    from './pages/AdminContactsPage';
import AdminContactDetailPage from './pages/AdminContactDetailPage';
import AdminContactsImportPage from './pages/AdminContactsImportPage';
import AdminConflictCheckPage from './pages/AdminConflictCheckPage';
import AdminGlobalDatesPage from './pages/AdminGlobalDatesPage';
import AdminImportPage      from './pages/AdminImportPage';
import AdminMassEmailPage   from './pages/AdminMassEmailPage';
import AdminDiscoverySetsPage from './pages/AdminDiscoverySetsPage';
import AdminDiscoverySettingsPage from './pages/AdminDiscoverySettingsPage';
import AdminPracticeAreasPage from './pages/AdminPracticeAreasPage';
import AdminActivityLogPage from './pages/AdminActivityLogPage';
import AdminAIDiscoveryPage from './pages/AdminAIDiscoveryPage';
import SignupPage           from './pages/SignupPage';
import VerifyPage           from './pages/VerifyPage';
import AcceptInvitePage     from './pages/AcceptInvitePage';
import UniversalLoginPage         from './pages/UniversalLoginPage';
import HandoffPage                from './pages/HandoffPage';
import ResetPasswordPage          from './pages/ResetPasswordPage';
import AdminDiscoveryResponseListPage      from './pages/AdminDiscoveryResponseListPage';
import AdminDiscoveryResponseUploadPage    from './pages/AdminDiscoveryResponseUploadPage';
import AdminDiscoveryResponseWorkspacePage from './pages/AdminDiscoveryResponseWorkspacePage';
import AdminModulesPage      from './pages/AdminModulesPage';
import AdminFirmBillingPage  from './pages/AdminFirmBillingPage'; // pkg68
import AdminFirmWalletPage   from './pages/AdminFirmWalletPage';  // pkg68
import AdminModuleEditPage   from './pages/AdminModuleEditPage';
// pkg21 — firm-private AI modules (pkg18 re-land)
import AdminFirmModulesPage           from './pages/AdminFirmModulesPage';
import AdminFirmModuleReviewPage      from './pages/AdminFirmModuleReviewPage';
import AdminFirmModuleDocumentsPage   from './pages/AdminFirmModuleDocumentsPage'; // pkg60 — replaces Prepare + View Submissions
import AdminInternalModuleFillPage    from './pages/AdminInternalModuleFillPage'; // pkg36
import AdminClientModulesPage         from './pages/AdminClientModulesPage'; // pkg125
import AdminExchangePage              from './pages/AdminExchangePage'; // pkg98 — MightyExchange
import AdminHQExchangePage            from './pages/AdminHQExchangePage';
import AiModulePage                   from './pages/AiModulePage';

export const AuthContext = createContext(null);
export function useAuth() { return useContext(AuthContext); }

// ── Storage key constants (client portal) ────────────────────────────────────
const LS_TOKEN   = 'ryanlaw_token';          // access token (always localStorage)
const LS_REFRESH = 'ryanlaw_client_refresh'; // refresh token (set only when rememberMe)

const BASE = process.env.REACT_APP_API_URL || 'http://localhost:3001';

// pkg60 — the old per-module /prepare and /submissions routes live on as
// redirects so bookmarks and muscle memory land on the Documents view.
function RedirectToModuleDocuments() {
  const { id } = useParams();
  return <Navigate to={`/admin/dashboard/firm-modules/${id}/documents`} replace />;
}

function RequireAuth({ children }) {
  const { token, client } = useAuth();
  if (!token) return <Navigate to="/login" replace />;
  if (client?.must_change_password) return <Navigate to="/change-password" replace />;
  return children;
}

function RequireAdmin({ children }) {
  const { adminUser, loading } = useAdminAuth();
  if (loading) return (
    <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <div className="spinner" style={{ borderTopColor: '#0F1838', width: 24, height: 24 }} />
    </div>
  );
  if (!adminUser) return <Navigate to="/admin" replace />;
  return children;
}

function SetupGate({ children, setupRequired }) {
  if (setupRequired) return <Navigate to="/admin/setup" replace />;
  return children;
}

// Tiny helper so each admin route can be wrapped in one RequirePermission
// without dragging the JSX out into multiple lines per route.
const Gated = (perm, el) => (
  <RequirePermission requirement={perm}>{el}</RequirePermission>
);

// pkg79 (D-79-r2) — at hq.lawmighty.com the admin landing IS the HQ portal:
// the dashboard index redirects to /admin/dashboard/hq. Tenant firms render
// the normal dashboard.
function HqAwareDashboard() {
  const { firm } = useFirmSettings();
  if (firm?.is_hq) return <Navigate to="/admin/dashboard/hq" replace />;
  return <AdminDashboardPage />;
}

// pkg80 (D-80a) — hq.lawmighty.com has no client portal, so the bare root
// (and /login) go straight to /admin: typing the domain lands on the HQ
// login, and a live session bounces on to the dashboard → HQ page via the
// existing redirects. While firm info is still loading we hold on a blank
// screen instead of flashing the client login. Tenant firms are untouched.
function HqRootGate({ children }) {
  const { firm, loading } = useFirmSettings();
  if (loading) return null;
  if (firm?.is_hq) return <Navigate to="/admin" replace />;
  return children;
}

export default function App() {
  const [token,   setToken]   = useState(localStorage.getItem(LS_TOKEN));
  const [client,  setClient]  = useState(null);
  const [loading, setLoading] = useState(true);
  const [setupRequired, setSetupRequired] = useState(false);
  const refreshTimerRef = useRef(null);

  // Setup is a one-way transition: a fresh install starts "required", an
  // owner is created, and it stays done forever. So once we've ever seen
  // setup_required=false we cache that fact in localStorage and skip the
  // network round-trip on subsequent loads — that fetch is the single
  // biggest contributor to the cold-start delay on the login pages, since
  // a sleeping Render backend can take 30–60s to wake up.
  const [setupChecked,  setSetupChecked]  = useState(
    localStorage.getItem('ryanlaw_setup_done') === '1'
  );

  useEffect(() => {
    if (setupChecked) return; // cached "done" — nothing to check
    publicApi.getSetupStatus()
      .then(data => {
        const required = !!data.setup_required;
        setSetupRequired(required);
        setSetupChecked(true);
        if (!required) localStorage.setItem('ryanlaw_setup_done', '1');
      })
      .catch(() => { setSetupChecked(true); });
  }, [setupChecked]);

  // ── Silent token refresh helper ───────────────────────────────────────────
  function scheduleClientRefresh(delayMs) {
    if (refreshTimerRef.current) clearTimeout(refreshTimerRef.current);
    refreshTimerRef.current = setTimeout(async () => {
      const raw = localStorage.getItem(LS_REFRESH);
      if (!raw) return;
      try {
        const res = await fetch(`${BASE}/api/auth/refresh`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ refreshToken: raw }),
        });
        if (!res.ok) throw new Error('refresh failed');
        const data = await res.json();
        localStorage.setItem(LS_TOKEN, data.token);
        localStorage.setItem(LS_REFRESH, data.refreshToken);
        setToken(data.token);
        scheduleClientRefresh(7 * 60 * 60 * 1000);
      } catch {
        localStorage.removeItem(LS_TOKEN);
        localStorage.removeItem(LS_REFRESH);
        setToken(null);
        setClient(null);
      }
    }, delayMs);
  }

  // ── On startup: validate token or attempt silent restore from refresh token
  useEffect(() => {
    async function init() {
      const storedToken = localStorage.getItem(LS_TOKEN);
      if (storedToken) {
        try {
          const data = await api.me();
          setClient(data);
          // If a refresh token exists, keep the refresh cycle running.
          if (localStorage.getItem(LS_REFRESH)) {
            scheduleClientRefresh(7 * 60 * 60 * 1000);
          }
        } catch {
          // Access token expired — try refresh token before giving up.
          const raw = localStorage.getItem(LS_REFRESH);
          if (raw) {
            try {
              const res = await fetch(`${BASE}/api/auth/refresh`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ refreshToken: raw }),
              });
              if (!res.ok) throw new Error('expired');
              const refreshData = await res.json();
              localStorage.setItem(LS_TOKEN, refreshData.token);
              localStorage.setItem(LS_REFRESH, refreshData.refreshToken);
              setToken(refreshData.token);
              const meData = await fetch(`${BASE}/api/auth/me`, {
                headers: { Authorization: `Bearer ${refreshData.token}` },
              }).then(r => r.json());
              setClient(meData);
              scheduleClientRefresh(7 * 60 * 60 * 1000);
            } catch {
              localStorage.removeItem(LS_TOKEN);
              localStorage.removeItem(LS_REFRESH);
              setToken(null);
            }
          } else {
            localStorage.removeItem(LS_TOKEN);
            setToken(null);
          }
        }
      }
      setLoading(false);
    }
    init();
    return () => { if (refreshTimerRef.current) clearTimeout(refreshTimerRef.current); };
  }, []);

  useEffect(() => {
    function handleFocus() {
      if (token) {
        api.me().then(data => setClient(data)).catch(() => {});
      }
    }
    window.addEventListener('focus', handleFocus);
    return () => window.removeEventListener('focus', handleFocus);
  }, [token]);

  // login is called by LoginPage after a successful POST /api/auth/login.
  // refreshToken is only provided when rememberMe was checked.
  function login(newToken, clientData, refreshToken) {
    localStorage.setItem(LS_TOKEN, newToken);
    if (refreshToken) {
      localStorage.setItem(LS_REFRESH, refreshToken);
      scheduleClientRefresh(7 * 60 * 60 * 1000);
    } else {
      localStorage.removeItem(LS_REFRESH);
    }
    setToken(newToken);
    setClient(clientData);
  }

  async function logout() {
    const raw = localStorage.getItem(LS_REFRESH);
    try {
      if (raw) {
        await fetch(`${BASE}/api/auth/logout`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ refreshToken: raw }),
        });
      }
    } catch { /* best-effort — always clear locally */ }
    if (refreshTimerRef.current) clearTimeout(refreshTimerRef.current);
    localStorage.removeItem(LS_TOKEN);
    localStorage.removeItem(LS_REFRESH);
    setToken(null);
    setClient(null);
  }

  function handleSetupComplete() { setSetupRequired(false); }

  // Only block the initial render while we're validating an EXISTING session.
  // Unauthenticated visitors (login pages) render immediately — the setup
  // check runs in the background and SetupGate handles redirection once the
  // answer arrives. This is the key win for cold-start UX: the login form
  // appears right away so the user can start filling in credentials while
  // the backend wakes up.
  if (token && loading) return (
    <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#0F1838' }}>
      <div className="spinner" style={{ borderTopColor: '#fff', width: 24, height: 24 }} />
    </div>
  );

  return (
    <FirmSettingsProvider>
      <AdminAuthProvider>
        <AuthContext.Provider value={{ token, client, setClient, login, logout }}>
            <BrowserRouter>
              <Routes>
                <Route path="/admin/setup" element={
                  <AdminSetupPage onComplete={handleSetupComplete} alreadyDone={!setupRequired} />
                } />
                <Route path="/signup"        element={<SignupPage />} />
                <Route path="/terms"         element={<TermsPage />} />   {/* pkg84 — public */}
                <Route path="/privacy"       element={<PrivacyPage />} /> {/* pkg84 — public */}
                <Route path="/verify"        element={<VerifyPage />} />
                <Route path="/accept-invite" element={<AcceptInvitePage />} />
                <Route path="/universal-login" element={<UniversalLoginPage />} />
                <Route path="/auth/handoff"  element={<HandoffPage />} />
                <Route path="/reset-password" element={<ResetPasswordPage />} />

                <Route path="/login"           element={<HqRootGate><SetupGate setupRequired={setupRequired}><LoginPage /></SetupGate></HqRootGate>} />
                <Route path="/change-password" element={<SetupGate setupRequired={setupRequired}><ChangePasswordPage /></SetupGate>} />
                <Route path="/" element={<HqRootGate><SetupGate setupRequired={setupRequired}><RequireAuth><ClientModulesProvider><Layout /></ClientModulesProvider></RequireAuth></SetupGate></HqRootGate>}>
                  <Route index             element={<DashboardPage />} />
                  <Route path="demographic"    element={<DemographicPage />} />
                  <Route path="parenting-plan" element={<ParentingPlanPage />} />
                  <Route path="witnesses"      element={<WitnessPage />} />
                  <Route path="budget"         element={<BudgetPage />} />
                  <Route path="asset-ledger"   element={<AssetLedgerPage />} />{/* pkg26 */}
                  <Route path="adoption-intake" element={<AdoptionIntakePage />} />{/* pkg144 */}
                  <Route path="account"         element={<AccountSettingsPage />} />
                  <Route path="billing"         element={<ClientBillingPage />} />{/* pkg172a */}
                  <Route path="payment-methods" element={<ClientPaymentMethodsPage />} />{/* pkg198 */}
                  <Route path="child-support"    element={<ChildSupportPage />} />
                  <Route path="juvenile-info"   element={<JuvenileInfoPage />} />
                  <Route path="discovery"        element={<ClientDiscoveryListPage />} />
                  <Route path="discovery/:id"    element={<ClientDiscoveryWorkspacePage />} />
                  <Route path="modules/:id"      element={<ContentModulePage />} />
                  {/* pkg21 — firm-private AI module form (dynamic, from schema_json) */}
                  <Route path="ai-modules/:id"   element={<AiModulePage />} />
                </Route>

                {/* Admin portal */}
                <Route path="/admin" element={<SetupGate setupRequired={setupRequired}><AdminLoginPage /></SetupGate>} />
                <Route path="/admin/dashboard" element={<SetupGate setupRequired={setupRequired}><RequireAdmin><AdminLayout /></RequireAdmin></SetupGate>}>
                  <Route index element={<HqAwareDashboard />} />{/* pkg79 — HQ redirect at hq.lawmighty.com */}
                  <Route path="contacts"      element={Gated('manage_contacts',    <AdminContactsPage />)} />
                  <Route path="contacts/:id"  element={Gated('manage_contacts',    <AdminContactDetailPage />)} />
                  <Route path="import-contacts" element={Gated('manage_contacts',  <AdminContactsImportPage />)} />
                  <Route path="conflict-check"  element={Gated('run_conflict_check', <AdminConflictCheckPage />)} />
                  <Route path="firm-dates"    element={Gated('firm_dates',         <AdminGlobalDatesPage />)} />
                  <Route path="import"        element={Gated('import_clio',        <AdminImportPage />)} />
                  <Route path="mass-email"    element={Gated('mass_email',         <AdminMassEmailPage />)} />
                  <Route path="staff"         element={Gated('manage_staff',       <AdminStaffPage />)} />
                  <Route path="roles"         element={Gated('manage_staff',       <AdminRolesPage />)} />
                  <Route path="activity-log"  element={Gated('manage_staff',       <AdminActivityLogPage />)} />
                  <Route path="invoices"      element={Gated('view_billing',       <AdminInvoicesPage />)} />
                  <Route path="payments"      element={Gated('view_billing',       <AdminPaymentsPage />)} />{/* pkg174 */}
                  <Route path="invoices/new"  element={Gated('edit_billing',       <AdminGenerateInvoicePage />)} />
                  <Route path="invoices/:id"  element={Gated('view_billing',       <AdminInvoiceDetailPage />)} />
                  <Route path="trust"         element={Gated('view_billing',       <AdminTrustPage />)} />
                  <Route path="log-time"      element={Gated('edit_billing',       <AdminQuickTimePage />)} />
                  <Route path="ai-discovery"  element={Gated('generate_discovery', <AdminAIDiscoveryPage />)} />
                  <Route path="discovery-analysis" element={Gated('edit_clients', <AdminDiscoveryAnalysisLandingPage />)} /> {/* pkg148 */}
                  <Route path="discovery-responses"      element={Gated('discovery_response', <AdminDiscoveryResponseListPage />)} />
                  <Route path="discovery-responses/new"  element={Gated('discovery_response', <AdminDiscoveryResponseUploadPage />)} />
                  <Route path="discovery-responses/:id"  element={Gated('discovery_response', <AdminDiscoveryResponseWorkspacePage />)} />
                  <Route path="discovery-sets"     element={Gated('owner',    <AdminDiscoverySetsPage />)} />
                  <Route path="discovery-settings" element={Gated('owner',    <AdminDiscoverySettingsPage />)} />
                  <Route path="practice-areas"     element={Gated('owner',    <AdminPracticeAreasPage />)} />
                  <Route path="modules"        element={Gated('manage_modules', <AdminModulesPage />)} />
                  <Route path="modules/:id"    element={Gated('manage_modules', <AdminModuleEditPage />)} />
                  {/* pkg21 — firm-private AI modules (paths match the pages' navigate() calls) */}
                  <Route path="exchange"                      element={Gated('manage_modules', <AdminExchangePage />)} /> {/* pkg98 — MightyExchange */}
                  <Route path="firm-modules"                  element={Gated('manage_modules', <AdminFirmModulesPage />)} />
                  <Route path="firm-modules/:id/review"       element={Gated('manage_modules', <AdminFirmModuleReviewPage />)} />
                  <Route path="firm-modules/:id/documents"    element={Gated('manage_modules', <AdminFirmModuleDocumentsPage />)} /> {/* pkg60 */}
                  <Route path="firm-modules/:id/submissions"  element={<RedirectToModuleDocuments />} /> {/* pkg60 — old route */}
                  <Route path="firm-modules/:id/prepare"      element={<RedirectToModuleDocuments />} /> {/* pkg60 — old route */}
                  <Route path="firm-modules/:id/fill"         element={Gated('manage_modules', <AdminInternalModuleFillPage />)} /> {/* pkg36 */}
                  {/* pkg67b (D-67b8) — /case-types route removed with AdminCaseTypesPage (relic; mutations 410'd since Package 12d) */}
                  <Route path="firm-settings"  element={Gated('owner',          <AdminFirmSettingsPage />)} />
                  <Route path="firm-billing"   element={Gated('purchase_billing', <AdminFirmBillingPage />)} /> {/* pkg68 — owners pass any perm gate */}
                  <Route path="firm-wallet"    element={Gated('purchase_billing', <AdminFirmWalletPage />)} />  {/* pkg68 */}
                  <Route path="emergency-alert" element={Gated('owner',         <AdminEmergencyAlertPage />)} />{/* pkg32 */}
                  <Route path="hq"             element={Gated('owner',          <AdminHQPage />)} />{/* pkg79 — platform-owner firm enforced server-side */}
                  <Route path="hq/emails"      element={Gated('owner',          <AdminHQOnboardingEmailsPage />)} />{/* pkg153 — same server-side is_hq gate */}
                  <Route path="hq/marketing"   element={Gated('owner',          <AdminHQMarketingEmailsPage />)} />{/* pkg159 — same server-side is_hq gate */}
                  <Route path="hq/exchange"    element={Gated('owner',          <AdminHQExchangePage />)} />
                </Route>

                <Route path="/admin/create-client" element={<SetupGate setupRequired={setupRequired}><RequireAdmin><AdminLayout /></RequireAdmin></SetupGate>}>
                  <Route index element={Gated('edit_clients', <AdminCreateClientPage />)} />
                </Route>
                <Route path="/admin/clients" element={<SetupGate setupRequired={setupRequired}><RequireAdmin><AdminLayout /></RequireAdmin></SetupGate>}>
                  <Route index element={Gated('view_clients', <AdminClientsPage />)} />
                </Route>
                <Route path="/admin/closed-files" element={<SetupGate setupRequired={setupRequired}><RequireAdmin><AdminLayout /></RequireAdmin></SetupGate>}>
                  <Route index element={Gated('view_clients', <AdminClosedFilesPage />)} />
                </Route>
                {/* pkg105a — My Account: ungated on purpose (self-scoped; every admin role manages only their own sessions) */}
                <Route path="/admin/account" element={<SetupGate setupRequired={setupRequired}><RequireAdmin><AdminLayout /></RequireAdmin></SetupGate>}>
                  <Route index element={<AdminMyAccountPage />} />
                </Route>
                {/* pkg193 — firm accounting (operating + trust). Own path, same shell as the other admin pages. */}
                <Route path="/admin/accounting" element={<SetupGate setupRequired={setupRequired}><RequireAdmin><AdminLayout /></RequireAdmin></SetupGate>}>
                  <Route index element={Gated('view_billing', <AdminAccountingPage />)} />
                  <Route path="import" element={Gated('owner', <AdminPaymentImportPage />)} />{/* pkg195 */}
                </Route>
                <Route path="/admin/clients/:id" element={<SetupGate setupRequired={setupRequired}><RequireAdmin><AdminLayout /></RequireAdmin></SetupGate>}>
                  <Route index element={Gated('view_clients', <AdminClientDetailPage />)} />
                  <Route path="correspondence" element={Gated('edit_clients', <AdminClientCorrespondencePage />)} /> {/* pkg75 */}
                  <Route path="discovery-analysis" element={Gated('edit_clients', <AdminClientDiscoveryAnalysisPage />)} /> {/* pkg81 */}
                  <Route path="modules" element={Gated('edit_clients', <AdminClientModulesPage />)} /> {/* pkg125 — Client Modules workspace */}
                </Route>
                <Route path="*" element={<Navigate to="/" replace />} />
              </Routes>
            </BrowserRouter>
          </AuthContext.Provider>
      </AdminAuthProvider>
    </FirmSettingsProvider>
  );
}
